import { MineBlock, MineBlockResult } from './types'

export const MINE_GAME_SIZE = 5 // 5 x 5
export const MINES_DEFAULT = 3
export const INHOUSE_GAME_LAUNCH_MAPPER_KEY = 'INHOUSE_GAME_LAUNCH_MAPPER'
export const mineGameReturnToPlayer = 0.99

export const MINE_DEFAULT_BLOCK = { isUserOpened: false, value: MineBlockResult.Unknow } as MineBlock
